import React from "react";
import {fetchDataEntity} from "../../../../api/entity-data";
import Title from "../../../../components/Common/Title";
import Page from "../../../../layout/web/Page";
import Connector from "../../../../redux/connector";
import {PostToWoodChipping} from "../../../../api/http-post";
import {
    BuildComboDataClient,
    BuildComboDataCompany, BuildComboDataProject,
    FetchConfigDataService, FilterArrayDataWithConditions,
    IsConfigDataEmpty, SubmitNewChippingRate
} from "../../../../services/service-woodchipping";
import {Button, Col, DatePicker, Form, Input, Row} from "antd";
import {ArrayToSelectOption, FilterArrayByKey, UpCaseFirst} from "../../../../api/fn";
import ControllerSelectBox from "../../../../components/Common/ControllerInput/ControllerSelectBox";
import moment from "moment";
import GridItem from "../../../../components/Common/dashboard/Grid/GridItem";
import TableDataView from "../../../../components/Common/tables/TableDataView";
import DrawerFrame from "../../../../components/General/DrawerFrame";


class WoodChippingSettingRatePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            ConfigData: {},
            selectedCompany: "",
            selectedClient: "",
            selectedProject: "",
            targetDate: moment().format("YYYY-MM-DD"),

            InputRateChipping: "",
            InputRateSale: "",
            editMode: false,
        }

    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await fetchDataEntity("Data", "", "", this, undefined, "common/entity/WcRate/list");
        await this.fetchConfigData();
    }

    fetchConfigData = async () => {
        await FetchConfigDataService((res) => {
            this.setState({
                ConfigData: res
            })
        })

    }
    handleChangeInput = async (key, value) => {
        this.setState({
            [key]: value,
        })
    }
    handleGetInputValue = (key) => {
        if (typeof this.state[key] === "undefined") {
            return ""
        }
        return this.state[key];
    }
    onAddRecord = () => {
        const alertMsg = (field) => {
            alert(` ${field} can't empty, please selection before adding`)

        }
        if (this.state.selectedCompany === "") {
           alertMsg("company")
            return
        } else if (this.state.selectedClient === "") {
             alertMsg("client")
            return
        }else if (this.state.selectedProject === "") {
            alertMsg("project")
            return
        }

        this.setState({
            editMode: true
        })
    }
    onCancelRecord = () => {
        this.setState({
            editMode: false
        })
    }


    submitSearch = async () => {
        alert("coming soon!")

    }
    validationInputSubmit = () => {
        const alertMsg = (field) => {
            alert(`Validation fail, ${field} can't empty`)
            return false
        }
        if (this.state.InputRateChipping === "") {
            return alertMsg("chipping rate")
        } else if (this.state.InputRateSale === "") {
            return alertMsg("sale rate")
        }
        return true
    }
    onSubmit = async () => {
        if (!this.validationInputSubmit()) {
            return
        }
        await SubmitNewChippingRate(
            {
                org: this.state.selectedCompany,
                client: this.state.selectedClient,
                project: this.state.selectedProject,
                chipping:parseFloat(this.state.InputRateChipping),
                sale: parseFloat( this.state.InputRateSale),
            },
           async (res) => {
                console.log("Thank you, rate submited> ",res)
                alert("Thank you, rate submited")
               await this.fetchConfigData();
               this.onCancelRecord()
            })
    }

    renderAddRatePopOver = () => {
        if (!this.state.editMode) {
            return null
        }

        let inputs = [
            {label: "Chipping Rate", stateField: "InputRateChipping"},
            {label: "Sale Rate", stateField: "InputRateSale"},
        ]

        return (
            <DrawerFrame
                title={"Add Wood Chipping Rate"}
                visible={this.state.editMode}
                onClose={this.onCancelRecord}
                onSubmit={this.onSubmit}
            >
                {inputs.map(row => {
                    return (
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name={row.stateField}
                                    label={row.label}
                                    rules={[{required: true, message: 'Please enter ' + row.label}]}
                                >
                                    <Input
                                        placeholder={"Please enter user " + row.label}
                                        onChange={(e) => this.handleChangeInput(row.stateField, e.target.value)}
                                        value={this.handleGetInputValue(row.stateField)}
                                        defaultValue={this.handleGetInputValue(row.stateField)}
                                        required={row.mandatory}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    )
                })}


            </DrawerFrame>
        )
    }
    renderList = () => {
        let columns = [
            {id: "Chipping", label: "Chipping"},
            {id: "Sale", label: "Sale"},
        ];
        let storeData = FilterArrayDataWithConditions(
            this.state.ConfigData.Rates,
            [
                {field:"Org",value:this.state.selectedCompany},
                {field:"Client",value:this.state.selectedClient},
                {field:"Project",value:this.state.selectedProject},
            ])
        let data = {columns: columns, data: storeData};
        return (
            <GridItem xs={12} sm={12} md={12}>
                <br/>
                <TableDataView
                    {...data}
                    tableTitle={UpCaseFirst("Current Rate")}
                    onAddRecord={this.onAddRecord}
                    allowedAdd={true}
                />
            </GridItem>
        )
    }

    render() {
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup Wood Chipping Rate</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <Row gutter={18}>
                            <Col span={12}>
                                <ControllerSelectBox
                                    handleInput2={this.handleChangeInput}
                                    getHandleValue={this.handleGetInputValue}
                                    ls={BuildComboDataCompany(this.state.ConfigData)}
                                    label={"Company"}
                                    name={"selectedCompany"}
                                />
                            </Col>
                            <Col span={12}>
                                <ControllerSelectBox
                                    handleInput2={this.handleChangeInput}
                                    getHandleValue={this.handleGetInputValue}
                                    ls={BuildComboDataClient(this.state.ConfigData, this.state.selectedCompany)}
                                    label={"Client"}
                                    name={"selectedClient"}
                                />
                            </Col>
                        </Row>

                        <Row gutter={18}>
                            <Col span={24}>
                                <ControllerSelectBox
                                    handleInput2={this.handleChangeInput}
                                    getHandleValue={this.handleGetInputValue}
                                    ls={BuildComboDataProject(
                                        this.state.ConfigData,
                                        this.state.selectedCompany,
                                        this.state.selectedClient
                                    )}
                                    label={"Project"}
                                    name={"selectedProject"}
                                />
                            </Col>

                        </Row>

                        <Row gutter={18}>
                            <Col span={24}>
                                {this.renderList()}
                            </Col>
                        </Row>

                        {this.renderAddRatePopOver()}

                    </div>
                </div>
            </Page>
        )
    }

}

export default Connector(WoodChippingSettingRatePage);
const styles = {
    boxFilterInner: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: 10,
        paddingRight: 5,
        borderRight: "1px solid black",
        fontsize: 14,
        fontWeight: "bold"
    },
    boxFilter: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    dateRow: {
        display: "flex",
        flexDirection: "row"
    },
    datePickerBox: {
        height: 40,
        width: "100%"
    },
    row1Th: {
        border: "1px solid black",
    },
    rowForm: {
        marginBottom: 10,
        paddingBottom: 5,
        border: "0px solid lightgray",
        borderBottomWidth: 1,

    },

    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}